import * as Dd from '@radix-ui/react-dropdown-menu';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function DropdownMenu({
  trigger,
  children,
  align = 'end',
}: {
  trigger: ReactNode;
  children: ReactNode;
  align?: 'start' | 'center' | 'end';
}) {
  return (
    <Dd.Root>
      <Dd.Trigger asChild>{trigger}</Dd.Trigger>
      <Dd.Portal>
        <Dd.Content
          align={align}
          sideOffset={6}
          className={cn(
            'z-50 min-w-[200px] rounded-xl border border-line bg-white shadow-lift p-1',
            'animate-scale-in origin-top-right',
          )}
        >
          {children}
        </Dd.Content>
      </Dd.Portal>
    </Dd.Root>
  );
}

export function MenuItem({
  children,
  onSelect,
  danger = false,
  iconLeft,
}: {
  children: ReactNode;
  onSelect?: () => void;
  danger?: boolean;
  iconLeft?: ReactNode;
}) {
  return (
    <Dd.Item
      onSelect={onSelect}
      className={cn(
        'flex items-center gap-2 rounded-md px-2.5 py-2 text-body cursor-pointer',
        'outline-none focus:bg-canvas data-[highlighted]:bg-canvas',
        danger ? 'text-status-error' : 'text-ink',
      )}
    >
      {iconLeft}
      {children}
    </Dd.Item>
  );
}

export function MenuSeparator() {
  return <Dd.Separator className="my-1 h-px bg-line" />;
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return (
    <Dd.Label className="px-2.5 pt-2 pb-1 text-overline uppercase text-ink-hint">
      {children}
    </Dd.Label>
  );
}
